import { clientI18n } from '../ClientI18n.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
function parseDate(date) {
    if (date == undefined) return undefined;
    try {
        const parsed = date instanceof Date ? date : new Date(date);
        if (isNaN(parsed.getTime())) return undefined;
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    } catch (e) {
        return undefined;
    }
}
export function buildSectionsFromQualifiers(qualifiers) {
    const parsed = qualifiers.map((qualifier)=>{
        var _qualifier_title, _qualifier_location, _qualifier_joinUrl;
        return {
            title: (_qualifier_title = qualifier === null || qualifier === void 0 ? void 0 : qualifier.title) !== null && _qualifier_title !== void 0 ? _qualifier_title : '',
            location: (_qualifier_location = qualifier === null || qualifier === void 0 ? void 0 : qualifier.location) !== null && _qualifier_location !== void 0 ? _qualifier_location : '',
            date: parseDate(qualifier === null || qualifier === void 0 ? void 0 : qualifier.date),
            joinUrl: (_qualifier_joinUrl = qualifier === null || qualifier === void 0 ? void 0 : qualifier.joinUrl) !== null && _qualifier_joinUrl !== void 0 ? _qualifier_joinUrl : ''
        };
    });
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const upcomingWithDates = [];
    const upcomingTbd = [];
    const completed = [];
    for (const qualifier of parsed){
        if (qualifier.date == undefined) {
            upcomingTbd.push(qualifier);
            continue;
        }
        const date = qualifier.date;
        if (date < startOfToday) {
            completed.push(qualifier);
            continue;
        }
        upcomingWithDates.push(qualifier);
    }
    upcomingWithDates.sort((a, b)=>a.date.getTime() - b.date.getTime());
    completed.sort((a, b)=>b.date.getTime() - a.date.getTime());
    const format = (qualifier)=>{
        const date = qualifier.date == undefined ? clientI18n.t('strings:championship26Page.qualifiers.dateTbd') : qualifier.date.toLocaleDateString(UIUtilsEjsVariables.language, {
            month: 'long',
            day: 'numeric'
        });
        const description = {
            key: 'strings:championship26Page.qualifiers.details',
            options: {
                location: qualifier.location,
                date: date
            }
        };
        return {
            title: qualifier.title,
            description: description,
            joinUrl: qualifier.joinUrl
        };
    };
    const upcomingData = [
        ...upcomingWithDates.map(format),
        ...upcomingTbd.map(format)
    ];
    const completedData = completed.map(format);
    return [
        {
            title: {
                key: 'strings:championship26Page.qualifiers.upcoming'
            },
            openByDefault: true,
            showJoinBtns: true,
            qualifiers: upcomingData,
            contentId: 'championship26-qualifiers-section-upcoming',
            toggleId: 'championship26-qualifiers-upcoming-toggle-btn'
        },
        {
            title: {
                key: 'strings:championship26Page.qualifiers.completed'
            },
            openByDefault: false,
            showJoinBtns: false,
            qualifiers: completedData,
            contentId: 'championship26-qualifiers-section-completed',
            toggleId: 'championship26-qualifiers-completed-toggle-btn'
        }
    ];
}
